import { queryOptions } from '@tanstack/react-query'
import { achievementKeys } from './keys'
import { CACHE_TIMES } from './cache-config'
import { studentAchievementsApi } from '@/lib/api/student-achievements'

export function achievementsListQueryOptions() {
  return queryOptions({
    queryKey: achievementKeys.list(),
    queryFn: async () => {
      const { data, error } = await studentAchievementsApi().api.student.achievements.get()
      if (error) throw error
      return data
    },
    staleTime: CACHE_TIMES.STALE_LIST,
  })
}

export function achievementsSummaryQueryOptions() {
  return queryOptions({
    queryKey: achievementKeys.summary(),
    queryFn: async () => {
      const { data, error } = await studentAchievementsApi().api.student.achievements.summary.get()
      if (error) throw error
      return data
    },
    staleTime: CACHE_TIMES.STALE_DEFAULT,
  })
}
